export const APP_MOBILE_NAV_MEDIA_QUERY = "(max-width: 1023px)";

export function getWorkspaceChatVisibilityAction(
  mobileNavigationVisible: boolean,
): "chat:hide" | "chat:show" {
  return mobileNavigationVisible ? "chat:hide" : "chat:show";
}
